/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';

import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { logoutUser } from 'apis/accounts/users.api';
import { clearSiteStorage } from 'utils/storage';

const useLogout = () => {
  const { t } = useTranslation();
  const { mutate, isPending } = useMutation({ mutationFn: logoutUser });

  const navigate = useNavigate();

  const gotoLogin = () => {
    clearSiteStorage();
    navigate('/signin', { replace: true });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const logout = useCallback((error?: any, cb?: () => void) => {
    if (
      !error ||
      (error?.response &&
        (error?.response?.data?.message?.includes('Expired Token') ||
          error?.response?.data?.status === 'Forbidden Access' ||
          error?.response?.data?.status === 'Unauthorised'))
    ) {
      if (error) {
        console.log(error);
        message.warning(t('expired'));
      }
      mutate(undefined, {
        onSettled() {
          if (cb) {
            cb();
          }
          gotoLogin();
        },
      });
    }
  }, []);

  return { logout, isPending };
};

export default useLogout;
